import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PageHeader = ({ title, description, icon, breadcrumb, children }) => {
  return (
    <div className="page-header-container mb-4 position-relative overflow-hidden">
      <div className="page-header-bg-icon">
        {icon && <FontAwesomeIcon icon={icon} />}
      </div>
      <div className="page-header-inner d-flex align-items-center justify-content-between position-relative z-1">
        <div className="page-header-copy d-flex align-items-center">
          {icon && (
            <div className="page-header-icon-wrapper d-flex align-items-center justify-content-center">
              <FontAwesomeIcon icon={icon} size="xl" fixedWidth />
            </div>
          )}
          <div>
            {breadcrumb && <div className="page-header-breadcrumb">{breadcrumb}</div>}
            <h2 className="page-header-title mb-1">{title}</h2>
            {description && <div className="page-header-desc">{description}</div>}
          </div>
        </div>
        {children && (
          <div className="page-header-actions">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
